import styled from "styled-components";

// Active/inactive pill button for map layer toggles (dungeons/addresses/drawing).
// Shared by home and pinmonkey lobby.
export const MapToggleButton = styled.button`
  background: ${({ $active, theme }) =>
    $active ? theme.colors("chrome") : theme.colors("background", 0.92)};
  border: 1px solid
    ${({ $active, theme }) =>
      $active ? theme.colors("link") : theme.colors("foreground", 0.15)};
  color: ${({ $active, theme }) =>
    $active ? theme.colors("text") : theme.colors("foreground", 0.45)};
  font-family: "Silkscreen", monospace;
  font-size: 0.62rem;
  letter-spacing: 0.1em;
  padding: 0.4rem 0.75rem;
  cursor: pointer;
  text-transform: uppercase;
  white-space: nowrap;
  &:hover {
    border-color: ${({ theme }) => theme.colors("foreground", 0.35)};
    color: ${({ theme }) => theme.colors("foreground", 0.7)};
  }
`;
